import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import { ReservationProductService } from '../../services/reservation-product.service';
import { ReservationPaymentService } from '../../services/reservation-payment.service';
import { ReservationAbandonedService } from '../../services/reservation-abandoned.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonService } from '../../../person/services/person.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import * as moment from 'moment/moment';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { CounterService } from '../../../common/services/counter.service';
import { SaleService } from '../../../sales/services/sale.service';
import { SaleProductService } from '../../../sales/services/sale-product.service';
import { CounterSettings } from '../../../api.settings';
import { Observable } from 'rxjs/Observable';
import { ShopService } from '../../../configuration/services/shop.service';
import { UserService } from '../../../common/services/user.service';

@Component({
  selector: 'app-view-reservation',
  templateUrl: './view-reservation.component.html',
  styleUrls: ['./view-reservation.component.css'],
  providers: [ReservationService, PersonService, LabeledProductService,ReservationProductService,ReservationPaymentService,ReservationAbandonedService,CounterService,SaleService,SaleProductService,ShopService,UserService]
})
export class ViewReservationComponent implements OnInit {
  id: number = undefined;
  shop_id: number = undefined;
  private sub: any;
  reservation:any = {
      total_amount: 0,
      total_pending: 0
  };
  person:any = {};
  barcode;
  reservationsProductsToSave:any = [];
  reservationProducts:any = [];
  reservationPayments:any = [];
  paymentAmount: number = 0;
  reservationsAbandoned:any = [];
  productQuantity: number = 1;
  role: number = 2;
  shopSerie: string = '';
  methodOfPayment;
  method_of_payment: string = '';
  productDiscount;
  sale:any = {
    payment_method: '',
    total_credit_card: 0,
    total_cash: 0,
    total_delivered: 0,
    total_change: 0,
    payment_method_others: ''
  }
  addDiscount:boolean = false;
  addressTicket:string = '';
  shopNameTicket:string = '';
  createdTicket:string = '';
  shops:any = [];
  users:any = [];
  user:any=[];
  shop:number;
  index:number;
  userId:number;
  reservationPayment:any = {};
  reservationPaymentToPrint:any = {};
 
  constructor(private route: ActivatedRoute, private router: Router, private reservationService:ReservationService, private reservationPaymentService:ReservationPaymentService,
              private personService: PersonService, private labeledProductService:LabeledProductService, private reservationProductService:ReservationProductService, 
              private reservationAbandonedService:ReservationAbandonedService, public toastr: ToastsManager, vcr: ViewContainerRef, private counterService:CounterService, 
              private saleService:SaleService, private saleProductService:SaleProductService,private shopService:ShopService, private userService:UserService) { 
                this.toastr.setRootViewContainerRef(vcr);
              }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        if (params['id'] !== undefined){
         this.id = params['id'];
         this.getReservation();
        }
    });
    this.getShop();
    this.getUser();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
      this.shopSerie = this.checkSerie(parseInt(localStorage.getItem('shop')));
    }catch(e){
    }
  }

  getShop(){
    return new Promise((resolve, reject) => {
        this.shopService.get(parseInt(localStorage.getItem('shop')))
        .subscribe((shop) => {
            this.shop = shop;
            this.addressTicket=shop.address;
            this.shopNameTicket = shop.name;
            resolve();
        });
    });
  }


  getUser(){
    return new Promise((resolve, reject) => {
        this.userService.get(JSON.parse(localStorage.getItem('user')).id)
        .subscribe((user) => {
            this.user = user;
            this.createdTicket=user.username;
            resolve();
        });
    });
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  checkSerie(shopId){
    if (shopId == 1){
      return 'M';
    }else if (shopId == 5){
      return 'T';
    }else if (shopId == 7){
      return 'O';
    }else if (shopId == 8){
      return 'C';
    }
  }

  findPerson(){
    let nif = this.person.nif;
    this.person = {};
    let params={
      nif: nif
    }
    this.personService.query(params)
    .subscribe((people) => {
        if (people[0] === undefined){
            this.person.nif = nif;
        }else{
            var person = people[0];
            this.person = person;
        }
    });
  }

  savePerson(){
    this.personService.create(this.returnProperties(this.person))
    .subscribe((person) => {
        this.person = person;
    });
  }
  returnProperties(person){
    var properties = {
      nif: person.nif,
      name: person.name,
      surname: person.surname,
      address: person.address,
      cp: person.cp,
      town: person.town,
      state: person.state,
      telephone: person.telephone,
      mobile: person.mobile
    }
    if (person.id){
      properties['id'] = person.id;
    }
    return properties;
  }

  findLabeledProduct(){
    var params = {
        where: {barcode:this.barcode},
        sort: 'id DESC',
        limit: 2
    };
    this.labeledProductService.query(params).subscribe((labeledProducts) => {
        if (labeledProducts[0] && labeledProducts.length === 1){
            this.barcode = null;
            if (labeledProducts[0] && labeledProducts[0].id){
                var result = this.reservationProducts.filter((e)=>{
                  return e.labeledproduct.id === labeledProducts[0].id
                })
                if (result.length > 0){
                  this.toastr.error('', 'Este producto ya ha sido añadido, si desea añadirlo de nuevo borrelo del listado y añadalo con la cantidad correcta', {dismiss: "controlled",showCloseButton:true,toastLife: 6000});
                }else{
                  this.addLabeledProduct(labeledProducts[0]);
                }
            } 
        }
    });
  }

  addLabeledProduct(labeledProduct){
    if (labeledProduct.stock >= this.productQuantity){
      labeledProduct.quantity = this.productQuantity;
      labeledProduct.discount = this.productDiscount;
      labeledProduct.total = this.checkDiscount(labeledProduct.sale_price, labeledProduct.quantity, labeledProduct.discount)
      this.saveReservationProduct(labeledProduct);
      this.productQuantity = 1;
    }else{
      this.toastr.error('', 'Stock Insuficiente', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
    }
  }

  checkDiscount(sale_price, quantity, discount){
    var total = 0;
    var sale_price_with_quantity = parseFloat(sale_price) * quantity;
    var res = discount?discount.split("%"):""; 
    var res2 = discount?discount.split("e"):"";
    if (res.length > 1){//Percentage
      total = this.roundValue(sale_price_with_quantity - ((parseFloat(res[0]) * (sale_price_with_quantity/ 100))));
    }else if (res2.length > 1){//Money
      total = this.roundValue(sale_price_with_quantity - parseFloat(res2[0]));
    }else{
      total = this.roundValue(sale_price_with_quantity);
    }
    return total;
  }
  
  roundValue(value){
    return Math.round(value * 100) / 100;
  }


  saveReservation(){
    this.reservationService.create(this.returnPropertiesReservation(this.reservation))
    .subscribe((reservation) => {
        this.reservation = reservation;
        this.reservation.due_date = moment(reservation.due_date).format("YYYY-MM-DD");

    });
  }
  returnPropertiesReservation(reservation){
    var properties = {
      due_date: reservation.due_date,
      total_amount: reservation.total_amount,
      total_pending: reservation.total_pending,
      person: this.person.id,
      status: reservation.status,
    }
    if (reservation.id){
      properties['id'] = reservation.id;
    }
    return properties;
  }

  updateReservation(){
    return new Promise((resolve, reject) => {
      this.reservationService.update(this.returnPropertiesReservation(this.reservation))
      .subscribe((reservation) => {
          this.reservation = reservation;
          this.reservation.due_date = moment(reservation.due_date).format("YYYY-MM-DD");
          resolve();
      });
    });
  }

  getReservation(){
    this.reservationService.get(this.id)
    .subscribe((reservation) => {
        this.reservation = reservation;
        this.reservation.due_date = moment(reservation.due_date).format("YYYY-MM-DD");
        this.person = reservation.person;
        this.getReservationProducts();
        this.getReservationAbandoned();
        this.getReservationPayments();
    });
  }

  saveReservationProduct(labeledproduct){ 
      this.reservationProductService.create(this.returnPropertiesReservationProduct(labeledproduct))
      .subscribe(() => {
          //Update totals
          this.reservation.total_amount += labeledproduct.total;
          this.reservation.total_pending += labeledproduct.total;
          this.updateReservation();
          this.decreaseProductStock(labeledproduct.id, labeledproduct.stock, labeledproduct.quantity)
      });
    
  }

  deleteReservationProduct(reservationProduct){
    this.reservationProductService.delete(reservationProduct.id).subscribe(() => {
      //Update totals
      this.reservation.total_amount -= reservationProduct.total;
      this.reservation.total_pending -= reservationProduct.total;
      this.updateReservation();
      this.incrementProductStock(reservationProduct.labeledproduct.id, reservationProduct.labeledproduct.stock, reservationProduct.quantity)
    });
  }

  getReservationProducts(){
    this.reservationProductService.query({reservation: this.reservation.id}).subscribe((payments) => {
      this.reservationProducts = payments
    });
  }
  returnPropertiesReservationProduct(product){
    var properties = {
      labeledproduct_id: product.id,
      quantity: product.quantity,
      sale_price: product.sale_price,
      total: product.total,
      discount: product.discount,
      reservation_id: this.reservation.id
    }
    return properties;
  }

  saveReservationPayment(){ 
   if (this.methodOfPayment!= null){
      this.reservationPaymentService.create(this.returnPropertiesReservationPayment())
        .subscribe((reservationPayment) => {
          this.getReservationPayments().then(()=>{
            //Update totals
            this.reservation.total_pending -= this.paymentAmount;
            this.reservation.due_date = moment().add(1,'month').format("YYYY-MM-DD");
            this.updateReservation().then(()=>{
              this.printPartialPaymentTicket(this.reservationPayments[this.reservationPayments.length-1],this.reservationPayments.length);
              this.paymentAmount = 0;    
            });     
          });
      });   
   }
  }

  printPartialPaymentTicket(reservationPayment,index){
    this.reservationPaymentToPrint = reservationPayment;
    this.reservationPaymentToPrint.index = index;
    setTimeout(()=>{
      this.printTicket();
    },100)
  }

  printTicketReturnAbandoned(reservationAbandoned,index){
    this.reservationPaymentToPrint.index = index;
    this.reservationPaymentToPrint.number_with_serie = reservationAbandoned.number_with_serie;
    this.reservationPaymentToPrint.createdAt = reservationAbandoned.createdAt;
    this.reservationPaymentToPrint.return_number_with_serie = reservationAbandoned.return_number_with_serie;
    setTimeout(()=>{
      this.printTicketTPV();
    },100)
  }

  printTicketAbandoned(reservationAbandoned,index){
    this.reservationPaymentToPrint.index = index;
    this.reservationPaymentToPrint.total_amount = reservationAbandoned.total_amount;
    this.reservationPaymentToPrint.return_number = reservationAbandoned.return_number;
    this.reservationPaymentToPrint.number_with_serie = reservationAbandoned.number_with_serie;
    this.reservationPaymentToPrint.createdAt = reservationAbandoned.createdAt;
    this.reservationPaymentToPrint.return_number_with_serie = null;
    setTimeout(()=>{
      this.printTicketTPV();
    },100)
  }
  
  
  returnPropertiesReservationPayment(){
    var properties = {
      total_amount: this.paymentAmount,
      reservation_id: this.reservation.id,
      method_of_payment: this.methodOfPayment 
    }
    return properties;
  }

  getReservationPayments(){
    return new Promise((resolve, reject) => {
      this.reservationPaymentService.query({reservation: this.reservation.id}).subscribe((payments) => {
        this.reservationPayments = payments;
        resolve();
      });
    })
  }

  deleteReservationPayment(reservationPayment){
    this.reservationPaymentService.delete(reservationPayment.id).subscribe(() => {
      this.getReservationPayments();
      this.reservation.total_pending += reservationPayment.total_amount;
      this.updateReservation();
    });
  }


  saveReservationAbandoned(){ 
    this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
      this.reservationAbandonedService.create(this.returnPropertiesReservationAbandoned(counter, this.shopSerie+counter))
        .subscribe(() => {
          this.reservation.status = 1;
          this.updateReservation();
          this.getReservationAbandoned().then(()=>{
            this.printTicketAbandoned(this.reservationsAbandoned[this.reservationsAbandoned.length-1], this.reservationsAbandoned.length-1);
          })
          this.updateStockForAllProducts(true);
      });
    });
  }

  returnPropertiesReservationAbandoned(number, number_with_serie){
    var properties = {
      total_amount: this.reservation.total_amount - this.reservation.total_pending,
      reservation_id: this.reservation.id,
      number: number,
      number_with_serie: number_with_serie
    }
    return properties;
  }

  getReservationAbandoned(){
    return new Promise((resolve, reject) => {
      this.reservationAbandonedService.query({reservation_id: this.reservation.id}).subscribe((reservationsAbandoned) => {
        this.reservationsAbandoned = reservationsAbandoned;
        resolve();
      });  
    });    
  }


  deleteReservationAbandoned(){
    return new Promise((resolve, reject) => {
      let reservationAbandoned = this.reservationsAbandoned.filter((e)=>{
        return e.return_number === null
      })[0];
      this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.RETURN_TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
        let body = {
          id: reservationAbandoned.id,
          return_number: counter,
          return_number_with_serie: this.shopSerie+counter
        }
        this.reservationAbandonedService.update(body).subscribe(() => {
          this.getReservationAbandoned().then(()=>{
            this.printTicketReturnAbandoned(this.reservationsAbandoned[this.reservationsAbandoned.length-1],this.reservationsAbandoned.length-1)
          });
          this.reservation.status = null;
          this.updateReservation();   
          this.updateStockForAllProducts(false);
        });
      });
    });
  }

  updateStockForAllProducts(increment){
    this.reservationProducts.forEach((p)=>{
      if (increment){
        this.incrementProductStock(p.labeledproduct.id, p.labeledproduct.stock,p.quantity);
      }else{
        this.decreaseProductStock(p.labeledproduct.id, p.labeledproduct.stock,p.quantity);
      }
    });
  }

  decreaseProductStock(labeledProductId, stock, quantity){
    let object = {
        id: labeledProductId,
        stock: stock - quantity
    };
    this.labeledProductService.update(object).subscribe((result) => {
      this.getReservationProducts();
    });
  }

  incrementProductStock(labeledProductId, stock, quantity){
    let object = {
        id: labeledProductId,
        stock: stock + quantity
    };
    this.labeledProductService.update(object).subscribe((result) => {
      this.getReservationProducts();
    });
  }


  checkCounterNumber(counterName, year){
    return new Promise((resolve, reject) => {
        let params = {
            where: {
                name:counterName, 
                year: year
            }
        }
        this.counterService.query(params).subscribe((result) => {
            result = result[0];
            if (result === undefined){
                this.counterService.create({name:counterName,year: year,counter:1}).subscribe(() => {
                    resolve(1)
                });
            }else{
                this.counterService.update({id:result.id,counter:result.counter + 1}).subscribe(() => {
                    resolve(result.counter + 1)
                });
            }
        });
    });
  }

  doSale(){
    let sale = {
        number: 1,
        number_with_serie:'',
        date:new Date(),
        total: this.reservation.total_amount,
        total_credit_card: this.sale.total_credit_card,
        total_cash: this.sale.total_cash,
        total_delivered: this.sale.total_delivered,
        total_change: this.sale.total_change,
        method_of_payment: this.sale.payment_method == 1?"Efectivo":this.sale.payment_method ==2 ?"Tarjeta":this.sale.payment_method == 3?"Mixto":this.sale.payment_method == 4?this.sale.payment_method_others:null,                        
        reservation : this.reservation.id
    }
    if (sale.method_of_payment){
        var params = {
            sort: 'id DESC',
            skip: 0,
            limit: 1
        };
        this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
            sale.number = counter;
            sale.number_with_serie = this.shopSerie+counter;
            this.saleService.create(sale).subscribe((sale) => {
               this.method_of_payment = this.sale.payment_method;
                let observableSaleProductsRequests = [];
                this.reservationProducts.forEach((reservationProducts)=>{
                    let object = {
                        sale_id: sale.id,
                        barcode: reservationProducts.labeledproduct.barcode?reservationProducts.labeledproduct.barcode:"",
                        description: reservationProducts.labeledproduct.description? reservationProducts.labeledproduct.description:"",
                        quantity: reservationProducts.quantity?reservationProducts.quantity:1,
                        sale_price: reservationProducts.sale_price,
                        discount: reservationProducts.discount?reservationProducts.discount:"",
                        total:reservationProducts.total,
                        labeledproduct_id: reservationProducts.labeledproduct.id,
                        method_of_payment:reservationProducts.method_of_payment,
                    }
                    this.checkDiscountForTicket(object);
                    observableSaleProductsRequests.push(this.saleProductService.create(object));
                });
                Observable.forkJoin(observableSaleProductsRequests)
                    .subscribe(data => {    
                        this.saleService.get(sale.id).subscribe((sale) => {
                            this.addressTicket = sale.shop.address;
                            this.createdTicket = sale.createdBy.name;
                            this.sale = sale;
                            this.reservation.status = 2;
                            this.updateReservation();
                            setTimeout( ()=>{
                                this.printTicketTPV();
                            },0)              
                        });
                }); 
            });
        });
    }else{
        this.toastr.error('', 'Debe seleccionar un método de pago', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
    }
  }

  calculateTotalChange(){
    if (this.sale.total_cash > 0){
        this.sale.total_change = this.roundValue(this.sale.total_delivered - this.sale.total_cash);
    }else {
        this.sale.total_change = this.roundValue(this.sale.total_delivered - this.reservation.total_pending);
    }
  }
  checkDiscountForTicket(saleProduct){
    if (saleProduct.discount !== null && saleProduct.discount !== '' && saleProduct.discount !== undefined){
        this.addDiscount = true;
    }
    return true;
  }
  printTicket(){    
    document.getElementById("ticketcuenta").classList.remove('hide'); 
    window.print();
    document.getElementById("ticketcuenta").classList.add('hide');   
  }
  
  printTicketTPV(){    
    document.getElementById("ticket").classList.remove('hide'); 
    window.print();
    document.getElementById("ticket").classList.add('hide');   
  }
}



// WEBPACK FOOTER //
// ./src/app/reservation/components/view-reservation/view-reservation.component.ts